<template>
  <div class="device-container">
    <a-tree
      v-if="groupTreeData.length"
      class="device-tree"
      :treeData="groupTreeData"
      :replaceFields="replaceFields"
      defaultExpandAll
      @select="treeNodeSelect"
    >
      <template #title="node">
        <div class="device-tree-node">
          <a-tag color="blue"> {{ node.type }}:{{ node.id }} </a-tag
          >{{ node.name }}
        </div>
      </template>
    </a-tree>
    <a-divider type="vertical" class="device-divider" />
    <router-view style="flex:1"></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      groupTreeData: [],
      replaceFields: {
        children: "children",
        title: "name",
        key: "id"
      }
    };
  },
  computed: {
    ...mapState(["groupTree"])
  },
  mounted() {
    if (this.groupTree.length) {
      this.groupTreeData = this.groupTree;
    }
  },
  methods: {
    treeNodeSelect(key, { selectedNodes }) {
      let data = selectedNodes[0].data.props;
      if (data?.self?.level == 100) {
        this.$router.push({ name: "EditProject", params: { id: data.id } });
      } else if (data?.type == "device") {
        this.$router.push({ name: "EditStation", params: { id: data.id } });
      } else {
        this.$router.push({ name: "EditGroup", params: { id: data.id } });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.device-container {
  display: flex;
  height: 100%;
}
.device-tree {
  width: 320px;
}
// .device-tree /deep/ .el-tree-node__content {
//   height: auto !important;
// }
.device-tree-node {
  max-width: 212px;
  padding: 0 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.device-divider {
  height: auto;
  margin: 0 2px;
  width: 2px;
}
/deep/ .ant-tree-node-content-wrapper {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
